import React, { useEffect, useState, useCallback } from 'react';
import {
    IonContent,
    IonPage,
    IonIcon,
    useIonAlert, IonLoading,
} from '@ionic/react';
import {
    addOutline,
    chevronBack,
    chevronForward, downloadOutline, eye, pencil, trash,
} from 'ionicons/icons';
import useStore from "../../zustand/useStore";
import {
    actionToApproveJobPortalJobPost, actionToDeleteCandidateJobProfilePostData,
    actionToDeleteJobPostData,
    actionToGetAdminJobPostingByFilter
} from "../../apiHelpers/CommonAction";
import {FacebookLoader} from "../../components/Loader/FacebookLoader";
import AddJobFormModal from "../../components/AddJobFormModal";
import JobDetailsSheetPopup from "../../components/JobDetailsSheetPopup";
import AddJobCandidateProfileModal from "../../components/AddJobCandidateProfileModal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const ITEMS_PER_PAGE = 10;

const AdminJobPortalPage = () => {
    const [isLoading,setIsLoading] = useState(false);
    const [dataForEditing,setDataForEditing] = useState(null);
    const [addJobModalSheet, setAddJobModalSheet] = useState(false);
    const [selectedUserType, setSelectedUserType] = useState(1);
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [jobDetailsData, setJobDetailsData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const { jobPostingState } = useStore();
    const { jobPostings, loading, totalCount } = jobPostingState;
    const [presentAlert] = useIonAlert();
    const pageCount = Math.ceil((totalCount || 0) / ITEMS_PER_PAGE);


    const openJobDetailPanel = (jobDetail)=>{
        setJobDetailsData(jobDetail);
        setIsDetailOpen(true);
    }

    const callFunctionToSetEditData = (data)=>{
        setDataForEditing(data);
        setAddJobModalSheet(true);
    }

    const callFunctionToSetAddModalSheet = ()=>{
        setDataForEditing(null);
        setAddJobModalSheet(true);
    }

    const fetchPageData = useCallback((page) => {
        const newOffset = (page - 1) * ITEMS_PER_PAGE;
        setCurrentPage(page);
        actionToGetAdminJobPostingByFilter(false, { offset: newOffset ,user_type:selectedUserType});
    }, [selectedUserType]);

    useEffect(() => {
        fetchPageData(1);
    }, [fetchPageData]);

    const handlePrev = () => {
        if (currentPage > 1) {
            fetchPageData(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < pageCount) {
            fetchPageData(currentPage + 1);
        }
    };

    const callFunctionToDeletedata = (id)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete this item.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        if(selectedUserType === 1){
                            await actionToDeleteJobPostData(id)
                        }else{
                            await actionToDeleteCandidateJobProfilePostData(id);
                        }
                    }},
            ],
        });
    }

    const callFunctionToApproveJobPost = (id,user_email)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to approve this job post.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Approve', role: 'confirm', handler: async () =>{
                        await actionToApproveJobPortalJobPost(id,user_email,selectedUserType)
                        fetchPageData(currentPage);
                    }},
            ],
        });
    }


    const downloadExcel = () =>{
        // 1. Map only the fields we want in Excel
        const sortedData = [...jobPostings].sort((a, b) => a.id - b.id);
        const formattedData = sortedData.map(item => ({
            ID: item.id,
            Title: item.title,
            Description: item.description,
            Company: item.company,
            Responsibilities: item.responsiblities,
            Status: item.status === 1 ? "Active" : "Inactive",
            Location: item.location,
            Experience: item.experience,
            'Salary Min': item.salary_min,
            'Salary Max': item.salary_max,
            Department: item.department,
            'Apply Email': item.apply_email,
            'Applied Members': item.applied_member_id_array,
            WorkType: item.work_type,
            Requirement: item.requirement,
            Category: item.category,
            PDF: item.pdf_url,
            Image: item.image_url,
            'Phone Number': item.phone_number,
            'Valid Date': new Date(item.valid_date).toLocaleDateString("en-GB"), // DD/MM/YYYY
            'Created At': new Date(item.created_at).toLocaleDateString("en-GB"),
            'Created By': item.created_by,
            Approved: item.is_approved ? "Yes" : "No",
        }));

        // 2. Convert JSON → worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // 3. Create workbook and append worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs");

        // 4. Generate Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        // 5. Trigger download
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "jobs.xlsx");
    }
    return (
        <IonPage>
            <IonContent className="ion-padding news-letter-content-page">
                <div className="admin_inner_tab_container">
                    <div className="header-row">
                        <div className={"d-flex ion-align-items-center w-full"}>
                            <h2 className="newsletter-heading mr-2">All Jobs</h2>
                            {/*<div className="admin-employee-filter admin_datatable_filter">
                                <select
                                    className={"pl-2"}
                                    value={selectedUserType}
                                    onChange={(e) => setSelectedUserType(Number(e.target.value))}>
                                    <option value={1}>Employee</option>
                                    <option value={2}>Candidate</option>
                                </select>
                            </div>*/}
                            <div className={"d-flex ion-align-items-center newsletter-heading_right ml-auto"}>
                                {(selectedUserType === 1) ?
                                    <IonIcon
                                        className="add_news_icon addnews-btn job-portal"
                                        onClick={() => callFunctionToSetAddModalSheet()}
                                        icon={addOutline}
                                    />:''
                                }

                                {jobPostings?.length > 0 ?
                                    (
                                        <button className="download-button" onClick={() => downloadExcel()}>
                                            <IonIcon size={1} icon={downloadOutline}  />
                                            <span>Download</span>
                                        </button>
                                    )
                                    /*<IonIcon
                                        className="add_news_icon"
                                        onClick={() => downloadExcel()}
                                        icon={download}
                                    />*/ :""}

                                <div className="filters-row admin_datatable_filter">
                                    {/* Month Filter */}
                                    <select
                                        value={selectedUserType}
                                        onChange={(e) => setSelectedUserType(Number(e.target.value))}>
                                        <option value={1}>Employee</option>
                                        <option value={2}>Candidate</option>
                                    </select>
                                </div>
                            </div>


                        </div>
                    </div>


                    <div className="newsletter-table-container">

                        <table className="newsletter-table">
                            <thead>
                            {selectedUserType === 1 ?
                                <tr>
                                    <th>Company</th>
                                    <th>Title</th>
                                    <th>Phone Number</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                                :
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone Number</th>
                                    <th>Category</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            }
                            </thead>
                            <tbody>
                            {(loading) ?
                               <>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                </>
                               :(jobPostings?.length > 0) ? (
                                    jobPostings.map((item) => (
                                        <tr key={item.id}>
                                            {selectedUserType === 1 ?
                                               <>
                                                   <td>
                                                       {item.company}
                                                   </td>
                                                   <td>{item.title}</td>
                                                   <td>
                                                       {item.phone_number}
                                                   </td>
                                                   <td>
                                                       {(!item?.is_approved) ?
                                                           <div onClick={() => callFunctionToApproveJobPost(item?.id,item?.user_email)}
                                                                className="filter_sheet_clear_all_btn approve">
                                                               Not Approved
                                                           </div>
                                                           :
                                                           <div className="filter_sheet_clear_all_btn approved">
                                                               Approved
                                                           </div>
                                                       }
                                                   </td>
                                                   <td className={"action_td"}>
                                                       <IonIcon icon={eye} onClick={()=>openJobDetailPanel(item)} className={"admin_delete_button_icon admin_view_icon eye_icon"}/>
                                                       <IonIcon icon={pencil} onClick={()=>callFunctionToSetEditData(item)} className={"admin_delete_button_icon pencil_icon admin_edit_icon"}/>
                                                       <IonIcon icon={trash} onClick={()=>callFunctionToDeletedata(item?.id)} className={"admin_delete_button_icon admin_delete_icon"}/>
                                                   </td>
                                               </>
                                                :
                                                <>
                                                    <td>
                                                        {item.name}
                                                    </td>
                                                    <td>
                                                        {item.email}
                                                    </td>
                                                    <td>
                                                        {item.phone_number}
                                                    </td>
                                                    <td>{item.category}</td>
                                                    <td>
                                                        {(!item?.is_approved) ?
                                                            <div onClick={() => callFunctionToApproveJobPost(item?.id)}
                                                                 className="filter_sheet_clear_all_btn approve">
                                                                Not Approved
                                                            </div>
                                                            :
                                                            <div className="filter_sheet_clear_all_btn approved">
                                                                Approved
                                                            </div>
                                                        }
                                                    </td>
                                                    <td className={"action_td"}>
                                                        <IonIcon icon={pencil} onClick={()=>callFunctionToSetEditData(item)} className={"admin_delete_button_icon"}/>
                                                        <IonIcon icon={trash} onClick={()=>callFunctionToDeletedata(item?.id)} className={"admin_delete_button_icon"}/>
                                                    </td>
                                                </>
                                            }
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" style={{ textAlign: 'center', padding: '1rem' }}>
                                            No job found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === 1}
                            onClick={handlePrev}
                        >
                            <IonIcon icon={chevronBack} />
                        </button>
                        <span className="page-info">
                            Page {currentPage} of {pageCount}
                        </span>
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === pageCount}
                            onClick={handleNext}
                        >
                            <IonIcon icon={chevronForward} />
                        </button>
                    </div>
                </div>
            </IonContent>
            {/*/////// JOB POSTING //////////////*/}
            {(selectedUserType === 1) ?
                <AddJobFormModal isOpen={addJobModalSheet} fromAdminList={true} onClose={() => setAddJobModalSheet(false)} setIsLoading={setIsLoading} dataForEditing={dataForEditing}/>
                :
                <AddJobCandidateProfileModal isOpen={addJobModalSheet} fromAdminList={true} onClose={() => setAddJobModalSheet(false)} setIsLoading={setIsLoading} dataForEditing={dataForEditing}/>
            }
            {/*/////// JOB POSTING //////////////*/}
            {(selectedUserType === 1) ?
                <JobDetailsSheetPopup isOpen={isDetailOpen}
                                      jobDetailsData={jobDetailsData}
                                      onDidDismiss={() => setIsDetailOpen(false)}/>
                :
                ''
            }
            <IonLoading isOpen={isLoading} className={"loading_loader_spinner_container"} message={"Please Wait..."}/>
        </IonPage>
    );
};

export default AdminJobPortalPage;
